//include 28
jQuery(function () {
    var utilities = {
        formatPrice: function (value, simple, decimalSeparator) {
            var numeric = parseFloat(value);
            decimalSeparator = decimalSeparator || ",";
            var simple = simple || false;
            if (numeric % 1 === 0 && !simple) {
                //whole number
                numeric = numeric.toFixed(0);
                numeric = numeric + ",-";
            } else {
                numeric = numeric.toFixed(2);
                numeric = numeric
                    .toLocaleString("de-DE")
                    .replace(".", decimalSeparator);
                //if(!simple)
                //    numeric +="-";
            }
            return numeric;
        },
        scrollTo: function (
            selectorOrOffset,
            ignoreHeader,
            additionalOffset,
            supressAnimation,
            callback
        ) {
            var offset = selectorOrOffset;
            ignoreHeader = ignoreHeader || false;
            additionalOffset = additionalOffset || 0;
            supressAnimation = supressAnimation || false;

            if (offset instanceof jQuery) {
            }
            if (isNaN(offset)) {
                var element = selectorOrOffset;
                if (!(element instanceof jQuery)) var element = $(selectorOrOffset);
                if (element.length == 0) return;

                offset = element.offset().top;
                offset = offset + additionalOffset;
                if (!ignoreHeader) {
                    offset -= $(".header").height();
                }
            }
            if (!supressAnimation) {
                $("html, body").animate(
                    {
                        scrollTop: offset
                    },
                    800,
                    () => {
                        if (callback) {
                            callback();
                        }
                    }
                );
            } else {
                $("html, body").scrollTop(offset);
                if (callback) {
                    callback();
                }
            }
        },
        parseUrl: function (url) {
            var splitted = url.split("?");
            var baseUrl = splitted[0];
            var queryParameters = {};
            if (splitted.length > 1) {
                var queryParts = splitted[1].split("&");
                $.each(queryParts, function (index, value) {
                    var kvp = value.split("=");
                    if (kvp.length < 2) return true;
                    queryParameters[kvp[0]] = kvp[1];
                });
            }
            return {
                baseUrl: baseUrl,
                queryParameters: queryParameters
            };
        },
        buildUrl: function (parsedUrl) {
            var queryParts = [];
            $.each(parsedUrl.queryParameters, function (key, value) {
                queryParts.push(key + "=" + value);
            });
            if ($.isEmptyObject(parsedUrl.queryParameters)) {
                return parsedUrl.baseUrl;
            }
            return parsedUrl.baseUrl + "?" + queryParts.join("&");
        },
        addParameterToUrl: function (url, key, parameter, encodeUrls) {
            encodeUrls = encodeUrls || false;
            var parsedUrl = utilities.parseUrl(url);
            key = encodeURI(key);
            if (!encodeUrls) parameter = encodeURI(parameter);
            else parameter = encodeURIComponent(parameter);
            parsedUrl.queryParameters[key] = parameter;
            return utilities.buildUrl(parsedUrl);
        },
        removeParameterFromUrl(url, key) {
            var parsedUrl = utilities.parseUrl(url);
            key = encodeURI(key);
            if (!!parsedUrl.queryParameters[key])
                delete parsedUrl.queryParameters[key];
            return utilities.buildUrl(parsedUrl);
        },
        getOverflows: function ($el) {
            var rect = $el[0].getBoundingClientRect();

            var offscreen = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            };

            if (rect.left < 0) offscreen.left = Math.abs(rect.left);
            if (rect.top < 0) offscreen.top = Math.abs(rect.top);
            if (rect.right > window.innerWidth)
                offscreen.right = Math.abs(rect.right - window.innerWidth);
            if (rect.bottom > window.innerHeight)
                offscreen.bottom = Math.abs(rect.bottom - window.innerHeight);

            return offscreen;
        },
        isTouchDevice() {
            return "ontouchstart" in window || "onmsgesturechange" in window;

            /*
                   'ontouchstart'         => works on most browsers
                   'onmsgesturechange'    => works on IE10 with some false positives
                  */
        },
        isIE() {
            var myNav = navigator.userAgent.toLowerCase();
            return myNav.indexOf("msie") != -1 ? parseInt(myNav.split("msie")[1]) : false;
        },
        hasLocalStorage() {
            if (!!window.localStorage) {
                try {
                    localStorage.setItem("test", "test");
                    localStorage.removeItem("test");
                    return true;
                } catch (e) {
                    return false;
                }
            }
            return false;
        },
        addUrlParameters(url, urlParameters) {
            if (!urlParameters || $.isEmptyObject(urlParameters)) {
                return url;
            }
            var parser = document.createElement("a");
            parser.href = url;
            if (!parser.hash) {
                parser.hash = "#";
            }
            if (parser.hash.indexOf("?") !== -1) {
                parser.hash += "&" + $.param(urlParameters);
            } else {
                parser.hash += "?" + $.param(urlParameters);
            }
            return parser.href;
        },
        isIframe: () => {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        getMapRegion: (id) => {
            var region = window.pixelpoint.domainService.get('region');
            var regionOnMap = window.pixelpoint.domainService.get('regionOnMap');
            if (!!region && !!regionOnMap) {
                if (region == id) {
                    return regionOnMap;
                }
            }
            return id;
        },
        getLanguageId: () => {
            var languageId = 0;
            var langObject = $("[data-language-obj]").data("language-obj");
            if (!!langObject) {
                languageId = langObject.id;
            }
            return languageId;
        },
        getAjaxUrl: (urlAppend, languageId) => {
            var languagesOnSameDomain = window.pixelpoint.domainService.get('languagesOnSameDomain');
            var ajaxUrlParts = [];
            if (!languagesOnSameDomain) {
                // if languages are running on different domains we return a language independent url
                ajaxUrlParts = ['/index.php'];
            } else {
                //first we define a language if, if not given we try to take it from the document
                if (!languageId && languageId !== 0) {
                    languageId = utilities.getLanguageId();
                }
                //we check if pretty urls are defined
                var ajaxPrettyUrls = window.pixelpoint.domainService.get('sameDomainAjaxUrls');
                if (!!ajaxPrettyUrls && !!ajaxPrettyUrls[languageId]) {
                    ajaxUrlParts = [ajaxPrettyUrls[languageId]];
                } else {
                    ajaxUrlParts = ['/index.php'];
                }
            }
            if (!!urlAppend){
                // we replace any occurence of index.php!
                urlAppend = urlAppend.replace('/index.php', '');
                if(urlAppend.length > 0 && urlAppend.charAt(0) === '?')
                    urlAppend = urlAppend.slice(1);
                if(!!urlAppend)
                    ajaxUrlParts.push(urlAppend);
            }
            return ajaxUrlParts.join('?');
        },
        getSysPageUrl: (languageId) => {
            var languagesOnSameDomain = window.pixelpoint.domainService.get('languagesOnSameDomain');
            var result = {
                baseUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : ''),
                useAjaxRenderPageId: true,
                ajaxRenderPageId: window.pixelpoint.domainService.get("ajaxRenderPage")
            };
            if (!languagesOnSameDomain) {
                // if languages are running on different domains we return a language independent url
                result.baseUrl = `${result.baseUrl}/index.php`;
            } else {
                //first we define a language if, if not given we try to take it from the document
                if (!languageId && languageId !== 0) {
                    languageId = utilities.getLanguageId();
                }
                var ajaxPrettyUrls = window.pixelpoint.domainService.get('ajaxModuleReloadPrettyUrls');
                if (!!ajaxPrettyUrls && !!ajaxPrettyUrls[languageId]) {
                    result.baseUrl = `${result.baseUrl}/${ajaxPrettyUrls[languageId]}`;
                    result.useAjaxRenderPageId = false;
                } else {
                    result.baseUrl = `${result.baseUrl}/index.php`;
                }
            }
            return result;
        }
    };
    window.pixelpoint.utilities = utilities;
});
